import {
  DATE_COLUMNS,
  TEXT_COLUMNS,
} from '../../../common/components/materials/materialPresentationConstants';
import { COLUMN_FILTER_KIND } from '../constants/materialDashboardConstants';

/**
 * Tipo de dato de una columna del tablero para filtrarla (texto, número o fecha).
 * @param {string} column Clave de la columna.
 * @returns {string} Valor de `COLUMN_FILTER_KIND`.
 */
export const getColumnFilterKind = (column) => {
  if (DATE_COLUMNS.includes(column)) return COLUMN_FILTER_KIND.date;
  if (TEXT_COLUMNS.includes(column)) return COLUMN_FILTER_KIND.text;
  return COLUMN_FILTER_KIND.number;
};
